import { TrolleyList } from './trolley'

class AuthenticatedTrolleyList extends TrolleyList {
    getEntityKey() {
        return "customer/authenticated_trolley"
    }
}

export const authenticatedTrolleyList = new AuthenticatedTrolleyList("authenticated_trolley_default")
